import TaskCreate from '@/components/tasks/TaskCreate'
import TaskUpdate from '@/components/tasks/TaskUpdate'

const tasksRoutes = [
  { path: '/:type/:id/tasks/create', name: 'task_create', component: TaskCreate },
  { path: '/:type/:prospect_id/tasks/update/:id', name: 'task_update', component: TaskUpdate }
]

export default tasksRoutes



// WEBPACK FOOTER //
// ./src/router/tasks_routes.js